import Test from '@dashboard/common/Test'
import { bumpPendingThreadCount } from 'actions/messaging'
import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import { PrimarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import Input from 'components/ReusableComponents/Input'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import {
  socketHubs,
  socketKinds
} from 'components/ReusableComponents/MessagingSocket/socketTypes'
import useCopyText from 'hooks/useCopyText'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import userApi from 'services/api/user'
import { sessionExpiredHandler } from 'services/helpers/sessionExpiredHandler'
import LocalUserService from 'services/localUserService'

function getMessagingPath(hub) {
  switch (hub) {
    case socketHubs.Service:
      return 'messaging'

    case socketHubs.Sales:
      return 'incoming'

    case socketHubs.Review:
      return 'feedback'

    default:
      break
  }
}

function showNotificationFromSocketData(data) {
  const { title, body, hub, unit, kind, subsidiaryId } = data

  if (![socketKinds.ChatMessageReceived, socketKinds.ReviewReceived].includes(kind)) {
    return
  }

  const chatId = data?.chat?.chatId || data?.review?.chatid

  if (document.location.href.includes(`/${getMessagingPath(hub)}/${chatId}`)) {
    return
  }

  if ('serviceWorker' in navigator && 'PushManager' in window && window.Notification) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.showNotification(title, {
        body,
        icon: '//cdn.swaypay.io/logo.png',
        requireInteraction: true,
        data: {
          hub,
          unit,
          chatId,
          subsidiaryId
        }
      })
    })
  }
}

function showImportantNotification() {
  if ('serviceWorker' in navigator && 'PushManager' in window && window.Notification) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.showNotification('Attention required', {
        body: 'A guest wants to make a booking',
        icon: '//cdn.swaypay.io/urgent2.png',
        requireInteraction: true
      })
    })
  }
}

const Debug = () => {
  const [textAreaValue, setTextAreaValue] = useState(
    JSON.stringify({
      kind: 'ChatMessageReceived',
      action: 'MessageReceived',
      hub: 'Sales',
      unit: 'Chat',
      title: 'Notification title',
      chat: {
        content: 'hello there',
        chatId: 1318501,
        chatMessageId: '21312',
        senderName: 'Sinan',
        isSenderClient: true
      },
      chatId: 1318501,
      chatMessageId: 1446893,
      subsidiaryId: '08d850fa-aadc-4575-864e-8b43e782bc39',
      senderName: ' ',
      isSenderClient: true,
      isSenderSelf: false,
      content:
        'Okay we all need to talk about this Justin is at work he is calling me on his lunch break I show that Jamie is on board with her going back to the house Kristy also I have to go back to work tomorrow but I will go out there after work',
      scheduledOn: '2020-10-07T09:14:07.260327',
      sentOn: '2020-10-07T10:14:07.2603271',
      finalizedOn: '2020-10-07T10:14:07.2603272',
      deliveryError: null,
      requestControlKeyEcho: null,
      categoryId: null,
      feedback: null,
      deliveryStatus: 'Delivered'
    })
  )

  const dispatch = useDispatch()

  function handleSubmitNotificationForm(e) {
    e.preventDefault()
    showNotificationFromSocketData(JSON.parse(textAreaValue))
  }

  const [valueToCache, setValueToCache] = useState('')
  const [valueToGet, setValueToGet] = useState('')
  const [imgUrl, setImgUrl] = useState()

  // function cacheUrl(url) {
  //   caches.open('v1').then(cache => {
  //     const request = new Request(url, { method: 'GET' })

  //     cache.add(url)
  //     console.log(`${url} cached`)
  //   })
  // }

  function getFromCache(url) {
    caches.open('v1').then(function (cache) {
      cache
        .match(url)
        .then(response => response.blob())
        .then(blob => URL.createObjectURL(blob))
        .then(url => {
          setImgUrl(url)
        })
    })
  }

  const [apiMediaPath, setApiMediaPath] = useState(
    'https://dev-dashboard.swaypay.io/api-media/campaign/animated_1.gif'
  )

  const userService = new LocalUserService()

  const sessionId = userService.getCurrentUserInfo().sessionId

  const copy = useCopyText()

  const [threadCountBumpAmount, setThreadCountBumpAmount] = useState(1)

  const [threadCountBumpHub, setthreadCountBumpHub] = useState('service')

  function toggleInternalAdmin(isInternalAdmin) {
    userApi.setAsInternalAdmin({ isInternalAdmin })
  }

  return (
    <div style={{ padding: '20px 40px' }}>
      <h1>Restricted area</h1>
      <Test />
      <hr />
      <br />
      <PrimaryRegularButton onClick={() => toggleInternalAdmin(true)}>
        Become internal admin
      </PrimaryRegularButton>
      <br />
      <PrimaryRegularButton onClick={() => toggleInternalAdmin(false)}>
        Become regular user
      </PrimaryRegularButton>
      <hr />
      <br />
      Dispatch update thread count
      <br />
      <br />
      <TextInput
        value={threadCountBumpAmount}
        onChange={e => setThreadCountBumpAmount(e.target.value)}
        type="number"
        minValue={-1}
        maxValue={1}
      />
      <Dropdown
        value={threadCountBumpHub}
        options={{ sales: 'sales', service: 'service', review: 'review' }}
        onChange={e => setthreadCountBumpHub(e.target.value)}
      />
      <PrimarySmallButton
        onClick={() =>
          dispatch(bumpPendingThreadCount(threadCountBumpAmount, threadCountBumpHub))
        }
      >
        Dispatch
      </PrimarySmallButton>
      <hr />
      <br />
      <PrimarySmallButton onClick={() => copy(sessionId)}>
        Copy session id
      </PrimarySmallButton>
      <br />
      <PrimarySmallButton onClick={sessionExpiredHandler}>
        Renew session
      </PrimarySmallButton>
      <br />
      <Link to="/onboarding">
        <PrimarySmallButton>Go to PMS sync</PrimarySmallButton>
      </Link>
      <hr />
      <form onSubmit={handleSubmitNotificationForm}>
        <textarea
          value={textAreaValue}
          onChange={e => setTextAreaValue(e.target.value)}
          style={{ width: 400, height: 100 }}
          placeholder="paste socket data"
        ></textarea>
        <PrimarySmallButton disabled={textAreaValue === ''}>
          Show notification
        </PrimarySmallButton>
      </form>
      <br />
      <hr />
      <PrimarySmallButton onClick={showImportantNotification}>
        Show important notification
      </PrimarySmallButton>
      <br />
      <hr />
      Put to cache
      <br />
      <Input
        value={valueToCache}
        onChange={e => setValueToCache(e.target.value)}
        width={500}
      />
      {/* <PrimarySmallButton
        disabled={valueToCache === ''}
        onClick={() => cacheUrl(valueToCache)}
      >
        Cache url
      </PrimarySmallButton> */}
      <br />
      <hr />
      Find in cache
      <br />
      <Input
        value={valueToGet}
        onChange={e => setValueToGet(e.target.value)}
        width={500}
      />
      <PrimarySmallButton onClick={() => getFromCache(valueToCache)}>
        Get from cache
      </PrimarySmallButton>
      <img src={imgUrl} alt="something" />
      <br />
      <hr />
      <Input
        width={700}
        value={apiMediaPath}
        onChange={e => setApiMediaPath(e.target.value)}
      />
      <PrimarySmallButton
        onClick={() =>
          fetch(apiMediaPath, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Cache-Control': 'no-cache',
              'sp-auth': sessionId
            }
          })
        }
      >
        Fetch from api-media
      </PrimarySmallButton>
    </div>
  )
}

export default Debug
